import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SpinnerModule } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule, SpinnerModule, IconModule, FormsModule],
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
  ,schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UsersComponent implements OnInit {
  public users: any[] = [];
  public loading = true;
  public sendingPassword: { [key: string]: boolean } = {};
  public activePage: number = 1;
  public totalPages: number = 1;
  public totalItems: number = 0;
  public itemsPerPage: number = 10;

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.loadUsers(this.activePage);
  }

  loadUsers(page: number): void {
    this.loading = true;
    this.userService.getUsers(page, this.itemsPerPage).subscribe({
      next: (data) => {
        this.users = data.data || [];
        this.totalItems = data.pagination?.total ?? this.users.length;
        this.totalPages = data.pagination?.last_page ?? 1;
        this.activePage = page;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error('Error fetching users:', err);
      }
    });
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.loadUsers(page);
  }

  onItemsPerPageChange(): void {
    this.loadUsers(1);
  }

  editUser(index: number): void {
    const user = this.users[index];
    if (user && user.id) {
      this.router.navigate(['/users/edit', user.id]);
    }
  }

  onAddUser(): void {
    this.router.navigate(['/users/add']);
  }

  confirmSendPassword(user: any): void {
    if (!user || !user.id) return;
    const confirmed = confirm(`Are you sure you want to reset the password and send details to ${user.email}?`);
    if (confirmed) {
      this.sendingPassword[user.id] = true;
      this.userService.sendUserDetailsEmail(user.id).subscribe({
        next: (res) => {
          alert('User details email sent successfully.');
          this.sendingPassword[user.id] = false;
        },
        error: (err) => {
          alert('Failed to send user details email.');
          console.error('Send password error:', err);
          this.sendingPassword[user.id] = false;
        }
      });
    }
  }
}